<template>
    <div class="table">
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>{{ menuName }}</el-breadcrumb-item>
            </el-breadcrumb>
        </div>

        <div
            class="container"
            style="float:right;width:95%;"
            v-loading="loading"
            element-loading-background="rgba(255, 255,255,0.7)"
            :element-loading-text="loadingText">
            <el-form ref="form" :model="form" label-width="160px" style="max-width: 720px; margin-top: 16px;">
                <el-form-item label="开启会员学校设置">
                    <el-select
                        v-model="form.memberSchoolKey"
                        multiple
                        filterable
                        collapse-tags
                        clearable
                        placeholder="请选择学校（可为空）"
                        style="width: 100%;">
                        <el-option
                            v-for="item in schoolOptions"
                            :key="schoolOptionValue(item)"
                            :label="item.name"
                            :value="schoolOptionValue(item)">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div style="font-size: 14px; color: #909399; line-height: 22px; margin: 0 0 20px 160px; max-width: 720px;">
                温馨提示：学校开启会员功能需要在此设置
            </div>
            <div style="margin-left: 160px;">
                <el-button type="primary" @click="save">确定</el-button>
                <el-button @click="cancel">取消</el-button>
            </div>
        </div>
    </div>
</template>

<script>
import http from '../../../../common/http';

/** 与接口返回的 dictKey 一致 */
const MEMBER_SCHOOL_DICT_KEY = 'member_school_key';

export default {
    name: 'MemberSet',
    data() {
        return {
            menuName: '',
            loading: false,
            loadingText: '',
            form: {
                memberSchoolKey: []
            },
            initialMemberSchoolKey: [],
            schoolOptions: []
        };
    },
    created() {
        this.menuName = sessionStorage.getItem('selectMenuItem_key') || '';
        this.getSchoolOptions();
        this.getMemberConfig();
    },
    methods: {
        /** 下拉 value 与 dictVal 一致：优先学校码 schoolCode */
        schoolOptionValue(item) {
            if (item && item.schoolCode != null && String(item.schoolCode) !== '') {
                return String(item.schoolCode);
            }
            return item && item.id != null ? String(item.id) : '';
        },
        getSchoolOptions() {
            const url = this.listDeptUrl;
            const data = { parentId: '0' };
            this.apiPost(url, data).then((res) => {
                if (res.status === 200) {
                    this.schoolOptions = res.data.list || [];
                } else {
                    this.$commonFn.showTip(res.message, 3);
                }
            }, (err) => {
                console.log(err);
            });
        },
        parseDictRows(resData) {
            if (Array.isArray(resData)) {
                return resData;
            }
            if (resData && Array.isArray(resData.list)) {
                return resData.list;
            }
            return [];
        },
        extractMemberSchoolDictVal(rows) {
            const row = rows.find((r) => r.dictKey === MEMBER_SCHOOL_DICT_KEY);
            if (row && row.dictVal != null) {
                return String(row.dictVal);
            }
            return '';
        },
        applyMemberSchoolKeyFromString(val) {
            if (this.$util.isNotEmpty(val)) {
                this.form.memberSchoolKey = String(val)
                    .split(',')
                    .map((s) => s.trim())
                    .filter(Boolean);
            } else {
                this.form.memberSchoolKey = [];
            }
        },
        getMemberConfig() {
            this.loading = true;
            this.loadingText = '加载中...';
            const url = this.memberSetListUrl;
            this.apiPost(url, {}).then((res) => {
                if (res.status === 200) {
                    const rows = this.parseDictRows(res.data);
                    const raw = this.extractMemberSchoolDictVal(rows);
                    this.applyMemberSchoolKeyFromString(raw);
                    this.initialMemberSchoolKey = this.form.memberSchoolKey.slice();
                } else {
                    this.$commonFn.showTip(res.message, 3);
                }
                this.loading = false;
            }, (err) => {
                console.log(err);
                this.loading = false;
            });
        },
        save() {
            this.loading = true;
            this.loadingText = '正在保存...';
            const url = this.memberSetSaveUrl;
            const dictVal = Array.isArray(this.form.memberSchoolKey) && this.form.memberSchoolKey.length
                ? this.form.memberSchoolKey.join(',')
                : '';
            const reqJson = {};
            reqJson[MEMBER_SCHOOL_DICT_KEY] = dictVal;
            const data = {
                data: JSON.stringify(reqJson)
            };
            this.apiPost(url, data).then((res) => {
                if (res.status === 200) {
                    this.$commonFn.showTip(res.message, 1);
                    this.initialMemberSchoolKey = this.form.memberSchoolKey.slice();
                } else {
                    this.$commonFn.showTip(res.message, 3);
                }
                this.loading = false;
            }, (err) => {
                console.log(err);
                this.loading = false;
            });
        },
        cancel() {
            this.form.memberSchoolKey = this.initialMemberSchoolKey.slice();
        }
    },
    mixins: [http]
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/page/member/set/MemberSet.vue